import { mergeTranslations } from "ra-core";
import polyglotI18nProvider from "ra-i18n-polyglot";
import englishMessages from "ra-language-english";
import { raSupabaseEnglishMessages } from "ra-supabase-language-english";
import { ptBRMessages } from "../../locales/pt-BR";

const raSupabaseEnglishMessagesOverride = {
  "ra-supabase": {
    auth: {
      password_reset: "Check your emails for a Reset Password message.",
    },
  },
};

const raSupabasePortugueseMessagesOverride = {
  "ra-supabase": {
    auth: {
      password_reset: "Verifique seus emails para uma mensagem de redefinição de senha.",
    },
  },
};

export const i18nProvider = polyglotI18nProvider(
  (locale) => {
    if (locale === "pt-BR") {
      return mergeTranslations(
        englishMessages, // Base: inglês
        ptBRMessages, // Sobrescrever com português
        raSupabasePortugueseMessagesOverride,
      );
    }
    
    return mergeTranslations(
      englishMessages,
      raSupabaseEnglishMessages,
      raSupabaseEnglishMessagesOverride,
    );
  },
  "pt-BR", // Idioma padrão
  [
    { locale: "pt-BR", name: "Português (Brasil)" },
    { locale: "en", name: "English" }
  ],
  { allowMissing: true },
);
